import React, { useCallback, useEffect, useState } from 'react'
import './employess.css'
import EmployessItem from './EmployessItem'
import { message, Pagination } from 'antd'

const Employees = () => {
  const [text, setText] = useState("")
  const [data, setData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    e.preventDefault()
    setText(e.target.value)
    setCurrentPage(1) 
  }

  const fetchEmployess = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/employess`)
      if (response.ok) {
        const data1 = await response.json()
        setData(data1)
      } else {
        message.error("Server Hatası : Kullanıcılar Getirilemedi")
      }
    } catch (error) {
      console.log(error)
    }
  }, [apiUrl])

  useEffect(() => {
    fetchEmployess()
  }, [fetchEmployess])

  const filteredText = data.filter(
    (item) =>
      item.name.toLocaleLowerCase('tr').trim().includes(text.toLocaleLowerCase('tr').trim()) ||
      item.expertise.toLocaleLowerCase('tr').trim().includes(text.toLocaleLowerCase('tr').trim())
  );
  

  const paginatedData = filteredText.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  return (
    <div className="employess">
      <div className="employess-bg">Birlikte Daha Güçlüyüz!</div>
      <div className="employess-search">
        <input onChange={handleChange} type="text" placeholder='Çalışan ismi veya görevi ara ...' />
      </div>

    

      <div className="employess-list">
        {paginatedData.map((item) => (
          <EmployessItem key={item.id} item={item} />
        ))}
      </div>

    
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        align='center'
        total={filteredText.length}
        onChange={(page) => setCurrentPage(page)}
        style={{ textAlign: 'center',fontSize:"20px",padding:"30px" }}
      />
    </div>
  )
}

export default Employees
